import DepositInterestSettings from "@/models/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettings";

export default class AccountDepositInterestSettings extends DepositInterestSettings {
    overridden: boolean = false;
}